import { Action } from "./actionRepository";

export interface JavaScriptParams {
    externalAction: any;
}

export class JavaScriptAction implements Action {
    params: JavaScriptParams;
    constructor(params: JavaScriptParams) {
        this.params = params;
    }
    execute() {
        this.params.externalAction();
    }
}
